import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-send-email-success',
  templateUrl: './send-email-success.component.html',
  styleUrls: ['../reset-password/reset-password.css']
})
export class SendEmailSuccessComponent implements OnInit {

  constructor() { }
  ngOnInit() {
  }

}
